import { Link } from "react-router-dom";

export function Logo({ compact = false, light = false, className = "" }) {
  const nameColor = light ? "text-ink" : "text-white";
  return (
    <Link to="/" data-testid="logo-link" className={`flex items-center gap-2.5 group ${className}`}>
      <div className="relative shrink-0">
        <div className="absolute inset-0 rounded-full bg-gold/25 blur-md group-hover:bg-gold/45 transition-colors" />
        <img src="/pmr-logo.png" alt="PMR Events" className="relative w-10 h-10 object-contain" />
      </div>
      {!compact && (
        <div className="leading-none">
          <div className={`font-serif text-xl tracking-tight ${nameColor}`}>PMR <span className={light ? "text-gradient-royal" : "text-gradient-gold"}>Events</span></div>
          <div className={`text-[9px] uppercase tracking-[0.32em] mt-0.5 ${light ? "text-maroon/70" : "text-muted-foreground"}`}>Every Moment. Found.</div>
        </div>
      )}
    </Link>
  );
}
